import React__default from 'react';
import { format, isSameDay, subDays, isSameWeek, isSameYear } from 'date-fns';
import classnames from 'classnames';
import styles from './styles.css.js';

/**
 * A set of messages sent in quick succession. Each exchange in a conversation is headed by a date & time.
 */

var Exchange = function Exchange(_a) {
  var startedAt = _a.startedAt,
      children = _a.children; // TODO: This component should be stateful to track the current date.
  //   The method is impure because it uses `new Date`.

  var now = new Date();
  var date = null;
  var time = format(startedAt, 'h:mm a');

  if (isSameDay(startedAt, now)) {
    date = 'Today';
  } else if (isSameDay(startedAt, subDays(now, 1))) {
    date = 'Yesterday';
  } else if (isSameWeek(startedAt, now)) {
    date = format(startedAt, 'iiii');
  } else if (isSameYear(startedAt, now)) {
    date = format(startedAt, 'iii, MMM d');
  } else {
    date = format(startedAt, 'iii, MMM d, yyyy');
  }

  return React__default.createElement("div", null, React__default.createElement("div", {
    className: classnames(styles.label, styles.flat)
  }, React__default.createElement("hr", {
    className: styles.divider
  }), React__default.createElement("span", {
    className: styles.date
  }, date), React__default.createElement("span", {
    className: styles.time
  }, time), React__default.createElement("hr", {
    className: styles.divider
  })), React__default.createElement("ul", {
    className: styles.messages
  }, children));
};

export default Exchange;
//# sourceMappingURL=index.js.map
